import { render, staticRenderFns } from "./RoomsSkeleton.vue?vue&type=template&id=bc94f110&scoped=true"
import script from "./RoomsSkeleton.vue?vue&type=script&lang=js"
export * from "./RoomsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RoomsSkeleton.vue?vue&type=style&index=0&id=bc94f110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc94f110",
  null
  
)

export default component.exports